export default function AVERAGEIFS() {
  return (
    <div className="p-4">
      <h1>AVERAGEIFS</h1>
    </div>
  );
}
